import React from 'react';

import { Integration } from '@futrli-sdk/app-store';
import { Organisation, SyncHistoryItem } from '@futrli-sdk/organisations';

import { Reconciliation } from '../../../reconciliation';
import { SyncControlButtonContainer } from '../sync-button-container/sync-button-container';
import { SyncControlDatasourceState, SyncControlState } from '../../types';
import { SyncDataCard } from '../sync-data-card/sync-data-card';
import { SyncDataCardLoaderPlaceholder } from '../sync-data-card/sync-data-card-loader-placeholder';
import { SyncErrorMessage } from './sync-error-message';
import { SyncHistory } from '../sync-history/sync-history';
import { SyncLoadingMessage } from './sync-loading-message';

interface Props {
  syncControlState: SyncControlState;
  organisation: Organisation | null;
  integration?: Integration;
  isExcelOrganisation: boolean;
  datasourceState: SyncControlDatasourceState;
  syncHistory?: SyncHistoryItem[] | null;
  syncTimestamp: string;
  unreconciledTransactionsCount?: number | null;
  handleOauth2SyncNow: () => Promise<void>;
}

export const SyncSidebarContainerContent = ({
  syncControlState,
  organisation,
  integration,
  isExcelOrganisation,
  datasourceState,
  syncHistory,
  syncTimestamp,
  unreconciledTransactionsCount,
  handleOauth2SyncNow
}: Props) => {
  const isInitialDataFetching = [SyncControlState.LOADING, SyncControlState.LOAD_ERROR].includes(syncControlState);

  const isSyncingOrReconnecting =
    datasourceState === SyncControlDatasourceState.SYNCING ||
    datasourceState === SyncControlDatasourceState.RECONNECTING;

  if (isInitialDataFetching) {
    return <SyncDataCardLoaderPlaceholder organisation={organisation} integration={integration} />;
  }

  return (
    <>
      {datasourceState === SyncControlDatasourceState.SYNC_FAILED && <SyncErrorMessage />}
      <div style={{ backgroundColor: '#fff', padding: '16px 24px', borderRadius: '8px', position: 'relative' }}>
        <SyncDataCard
          organisation={organisation}
          integration={integration}
          datasourceState={datasourceState}
          syncTimestamp={syncTimestamp}
          isLoading={isSyncingOrReconnecting}
          unreconciledTransactionsCount={unreconciledTransactionsCount}
        />
        <Reconciliation
          unreconciledTransactionsCount={unreconciledTransactionsCount}
          isLoading={isSyncingOrReconnecting}
          syncFailed={datasourceState === SyncControlDatasourceState.SYNC_FAILED}
        />
        <SyncControlButtonContainer onSyncClick={handleOauth2SyncNow} isLoading={isSyncingOrReconnecting} />
      </div>
      {isSyncingOrReconnecting && <SyncLoadingMessage />}
      {!isExcelOrganisation && Array.isArray(syncHistory) && syncHistory.length > 0 && (
        <SyncHistory history={syncHistory} />
      )}
    </>
  );
};
